module.exports = __webpack_public_path__ + "img/arrcouvItalTerm.bffd7af9.png";